export class UserDashboard {
    constructor() {
        this.setProperties();
        this.setEvents();
    }

    setProperties() {
        this.$cancelOrderButtons = $( '.cancel-order-button');
        this.$promptOverlay = $( '.prompt-overlay' );
        this.$promptCancel = this.$promptOverlay.find( '.prompt-cancel' );
        this.$promptConfirm = this.$promptOverlay.find( '.prompt-confirm' );
        this.$form = null;
    }

    setEvents() {
        let self = this;

        this.$cancelOrderButtons.on( 'click', function ( event ) {
            event.preventDefault();
            event.stopPropagation();

            let $this = $( this );

            self.$form = $this.parent();
            self.$promptOverlay.addClass( 'active' );
        } );

        this.$promptCancel.on( 'click', ( event ) => {
            event.preventDefault();

            this.$promptOverlay.removeClass( 'active' );
        } );

        this.$promptConfirm.on( 'click', ( event ) => {
            event.preventDefault();

            this.$promptOverlay.removeClass( 'active' );

            if ( this.$form ) {
                this.$form.submit();
            }
        } );
    }


}
